var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select",
    { attrs: { name: _vm.name, id: _vm.id } },
    _vm._l(_vm.options, function (option) {
      return _c(
        "option",
        {
          key: option.value,
          class: option.classes,
          attrs: { disabled: option.disabled },
          domProps: {
            value: option.value,
            selected: option.value == _vm.selectedValue,
          },
        },
        [_vm._v(_vm._s(option.label))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }